import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Signup from '@/components/Signup'
import DashboardLayout from "../components/layuot/DashboardLayout"
import Dashboard from "@/components/Dashboard"
import Subscriptions from "@/components/Subscriptions"
import NotFound from "@/components/NotFound"
import Profile from "@/components/Profile"
import ResetPassword from "../components/ResetPassword";
import EmailConfirmed from "../components/EmailConfirmed";
import ResetPasswordForm from "@/components/ResetPasswordForm";

import constants from "@/config/constants";
import Support from "@/components/Support";
import LoginSocialRedirect from "@/components/LoginSocialRedirect";
import Transactions from "@/components/Transactions";
import ResidentialProxies from "@/components/ResidentialProxies.vue";
import WebScrapingAPI from "@/components/WebScrapingAPI.vue";
import DatacenterProxies from "@/components/DatacenterProxies.vue";
Vue.use(Router)

Vue.router = new Router({
    mode: "history",
    routes: [{
        path: '/login',
        name: "Login",
        component: Login,
        meta: {
            auth: false,
            title: "Login"
        }
    },
    {
        path: '/login/:type',
        name: "LoginSocialRedirect",
        component: LoginSocialRedirect,
        meta: {
            auth: false,
            title: "Login"
        }
    },
    {
        path: '/signup',
        name: "Signup",
        component: Signup,
        meta: {
            auth: false,
            title: "Sign Up"
        }
    },
    {
        path: '/reset_password',
        name: "ResetPassword",
        component: ResetPassword,
        meta: {
            auth: false,
            title: "Reset Password"
        }
    },
    {
        path: '/reset_password/:token',
        name: "ResetPasswordForm",
        component: ResetPasswordForm,
        meta: {
            auth: false,
            title: "Reset Password"
        }
    },
    {
        path: '/email_confirmed/:token',
        name: "EmailConfirmed",
        component: EmailConfirmed,
        meta: {
            auth: false,
            title: "Email Confirmation"
        }
    },
    {
        path: '/',
        name: "DashboardLayout",
        component: DashboardLayout,
        redirect: "/dashboard",
        children: [{
            path: "dashboard",
            name: "Dashboard",
            component: Dashboard,
            meta: {
                auth: true,
                title: "Dashboard"
            }
        },
        {
            path: "webscrapingapi",
            name: "WebScrapingAPI",
            component: WebScrapingAPI,
            meta: {
                auth: true,
                title: "Web Scraping API"
            }
        },
        {
            path: "residential",
            name: "ResidentialProxies",
            component: ResidentialProxies,
            meta: {
                auth: true,
                title: "Residential Proxies"
            }
        },
        {
            path: "datacenter",
            name: "DatacenterProxies",
            component: DatacenterProxies,
            meta: {
                auth: true,
                title: "Datacenter Proxies"
            }
        },
        {
            path: "subscriptions",
            name: "Subscriptions",
            component: Subscriptions,
            meta: {
                auth: true,
                title: "Subscriptions"
            }
        },
        {
            path: '/transactions',
            name: "Transactions",
            component: Transactions,
            meta: {
                auth: true,
                title: "Transactions"
            }
        },
        {
            path: '/profile',
            name: "Profile",
            component: Profile,
            meta: {
                auth: true,
                title: "Profile"
            }
        },
        {
            path: '/support',
            name: "Support",
            component: Support,
            meta: {
                auth: true,
                title: "Support"
            }
        },
        ]
    },
    {
        path: '*',
        name: "NotFound",
        component: NotFound,
        meta: {
            auth: false,
            title: "Not Found"
        }
    }
    ],
    scrollBehavior: (to, from, savedPosition) =>{
        if (savedPosition) {
            return savedPosition;
        }
        if (to.hash) {
            return { el: to.hash, behavior: "smooth" };
        } else {
            window.scrollTo(0, 0);
        }
    },
})

// eslint-disable-next-line no-unused-vars
Vue.router.afterEach((to) => {
    // Use next tick to handle router history correctly
    // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
    Vue.nextTick(() => {
        document.title = to.meta.title ? `${to.meta.title} - ${constants.TEXT.DEFAULT_TITLE}` : constants.TEXT.DEFAULT_TITLE;
    });
});

export default Vue.router;
